import { Box, Typography } from '@mui/material';
import styled from 'styled-components';

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const StoreName = styled(Typography)`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  min-width: 1px;
  font-size: 1.15rem;
  font-weight: bold;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    font-size: 1.2rem;
  }
`;

export const Description = styled(Box)`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
`;

/* export const Header = styled(Typography)`
  font-size: 1.125rem;
  font-weight: bold;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;

  ${({ theme }) => theme.breakpoints.down('xs')} {
    font-size: 0.875rem;
  }
`; */
